import get from 'lodash/get';

export const selectNotifications = (state) => get(state, 'notifications.unreadNotifications', []);
export const selectNotificationsCount = (state) => get(state, 'notifications.count', 0);
